import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  Lable,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import "../style.css";
import InterestedTutor from "../../../models/interestedtutor.modal";
import { Link } from "react-router-dom";
import SuggestedTutor from "../../../models/suggestedtutor.modal";
import tutorsModal from "models/tutors.modal";
import enquiriesModal from "models/enquiries.modal";
import Select from "react-select";
import Shortlistedtutors from "../../../models/shortlistedtutors.modal";
import EnquiryModal from "../../../models/enquiries.modal";
import Tutorsmodel from "../../../models/tutors.modal";
import Loader from "components/loader/Loader";
import { toast } from "lib/helper";
import subadminsModal from "models/subadmins.modal";

const LinkTutorsEnquiries = () => {
  const [modal1, setModal1] = useState(false);

  const toggleModal = () => {
    setModal1(!modal1);
  };
  const [modal2, setModal2] = useState(false);

  const toggleModal1 = () => {
    setModal2(!modal2);
  };
  const [modal3, setModal3] = useState(false);

  const toggleModal2 = () => {
    setModal3(!modal3);
  };
  const [modal4, setModal4] = useState(false);

  const toggleModal4 = () => {
    setModal4(!modal4);
  };

  const [modal5, setModal5] = useState(false);

  const toggleModal5 = () => {
    setModal5(!modal5);
  };
  const [modal6, setModal6] = useState(false);
  const toggleModal6 = () => {
    setModal6(!modal6);
  };
  const [modal7, setModal7] = useState(false);
  const toggleModal7 = () => {
    setModal7(!modal7);
  };
  const [inlinkEnquryid, setinlinkEnquryid] = useState(null);
  const [inlinkTutorid, setinlinkTutorid] = useState(null);
  const [parent, setParent] = useState();
  const [i_tutor, setI_tutor] = useState();
  const [enquryid, setenquryid] = useState();
  const [tutorid, settutorid] = useState();
  const [shortlistdata, setShortlistdata] = useState();
  const [s_tutor, setS_tutor] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [linktutordata, setLinkedtutordata] = useState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const parmas = useParams();
  console.log("new Check", parent);
  const handleSubmit1 = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append("enquiry_id", inlinkEnquryid);
    formData.append("tutor_id", inlinkTutorid);

   
    Tutorsmodel.createpakage(formData)
      .then((responce) => {
        helper.sweetalert.toast(responce?.data?.message, "success");
      })
      .catch((error) => {
        console.log("error last", error);
        helper.sweetalert.toast(error?.response?.data?.message, "warning");
      });
  };
  const getListData = async () => {
    setIsLoading(true);
    await enquiriesModal
      .parentDetails(parmas?.mid)
      .then((result) => {
        console.log("g---------", result);
        setIsLoading(false);
        if (result) {
          setDataList(result?.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error?.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };
 
  const suggestedtutorlist = async () => {
    SuggestedTutor.listAllNewEnquiry()
      .then((response) => {
        setS_tutor(response);
      })
      .catch((error) => {});
  };
  const intertestutorlist = async () => {
    InterestedTutor.listAllinterestedtutorbyId(parmas?.id)
      .then((response) => {
        setI_tutor(response);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getListData();
    suggestedtutorlist();
    intertestutorlist();
    ShortlistedTutorsall();
    Parentdetail();
  }, [location, parmas.mid]);

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to Assign tutors ", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          contact_usModel.delete(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      });
  };
  // adding shortlist tutor
  const shortlistTutors = (id) => {
    const enquiry_id = parmas?.id;
    const tutor_id = id;

    if (enquiry_id && tutor_id) {
      const form = new FormData();
      form.append("enquiry_id", enquiry_id);
      form.append("tutor_id", tutor_id);
      Shortlistedtutors.addshortlist(form)
        .then((response) => {
          helper.sweetalert.toast(response?.data?.message, "success");
          ShortlistedTutorsall();
        })
        .catch((error) => {
          helper.sweetalert.toast(error.response?.data?.message, "warning");
        });
    }
  };

  const[supervisorlist,setSupervisor]= useState();
  const getsupervisor = async () => {
   
    await subadminsModal.Getlist(parameters)
      .then((result) => {
    
        if (result) {
          setSupervisor(result?.data?.data);
          
        }
      })
      .catch((error) => {
       console.log("error",error)
      });
  };
console.log("fffff",supervisorlist)
  useEffect(() => {
    getsupervisor();
  }, [location]);
  // link tutor

  const Linktutor = async () => {
    const form = new FormData();
    form.append("enquiry_id", parmas?.id);
    form.append("tutor_id", tutorid);
    if (tutorid && parmas.id) {
      Tutorsmodel.linkedtutor(form)
        .then((responce) => {
          toast("sucessfully linked", "success");
          getlinktutorlist();
        })
        .catch((error) => {
          toast(error?.response?.data?.message, "warning");
        });
    }
  };

  //get linked tutor list
  const getlinktutorlist = async () => {
    if (parmas.id) {
      Tutorsmodel.getlinkedtutor(parmas.id)
        .then((responce) => {
          setLinkedtutordata(responce?.data);
        })
        .catch((error) => {});
    }
  };
  useEffect(() => {
    getlinktutorlist();
  }, []);

  const Parentdetail = async () => {
    EnquiryModal.getdetail(parmas?.id)
      .then((responce) => {
        setParent(responce);
        console.log("data-45", responce);
      })
      .then((error) => {
        console.log("error", error);
      });
  };
  
  // get all shorlisted data
  const ShortlistedTutorsall = async () => {
    Shortlistedtutors.shortlistAll(parmas?.id)
      .then((responce) => {
        setShortlistdata(responce);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [selectedClassType, setSelectedClassType] = useState("");

  const handleChangeClassType = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedClassType(selectedOption.value);
  };
  // select mode function
  const [selecttMode, setSelectMode] = useState("");
  const handleChangeMode = (event) => {
    const { value } = event.target;
    setSelectMode(value);
  };
  const item = [];
  const [allStudentget, setAllStudentGet] = useState("");
  const getListDataAllStudent = async () => {
    setIsLoading(true);
    await enquiriesModal
      .parentStudentget(parmas.id)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setAllStudentGet(result.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getListDataAllStudent();
  }, [location, parmas.id]);

  const handleSubmiteditParentDetails = (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("mobile", dataList?.mobile);
    // You can adjust the header configuration according to your API requirements
    enquiriesModal
      .editParentDeatils(form)
      .then((response) => {
        getListData();
        toggleModal();
        helper.sweetalert.toast(response?.data?.message, "success");
      })
      .catch((error) => {
        helper.sweetalert.toast(error?.response?.data?.name[0], "error");
      });
  };
  const [isLoadingDemoAdd, setIsLoadningDemoAdd] = useState(false);

  const adddemo = async (event) => {
    event.preventDefault();
    console.log("add demo");
    const form = new FormData(event.target);
    form.append("enquiry_id", inlinkEnquryid);
    form.append("tutor_id", inlinkTutorid);
    let originalDate = form.get("date");
    if (originalDate) {
      const date = new Date(originalDate);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      form.set("date", formattedDate);
      if (inlinkEnquryid && inlinkTutorid) {
        setIsLoadningDemoAdd(true);
        Tutorsmodel.scheduledemo(form)
          .then((responce) => {
            setIsLoadningDemoAdd(false);
            toggleModal7();
            console.log("redy", responce);
            helper.sweetalert.toast(responce?.data?.message, "success");
          })
          .catch((error) => {
            setIsLoadningDemoAdd(false);
            helper.sweetalert.toast(error?.response?.data?.message, "warning");
            console.log("error schudule", error);
          });
      }
    }
  };
  const demogiven = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("enquiry_id", inlinkEnquryid);
    form.append("tutor_id", inlinkTutorid);
    Tutorsmodel.demogiven(form)
      .then((responce) => {
        helper.sweetalert.toast(responce?.data?.message, "success");
      })
      .catch((error) => {
        console.log("error schudule demo given", error);
        helper.sweetalert.toast(error?.response?.data?.message, "warning");
      });
  };
  const [tutorOptions, setTutorOptions] = useState([]);
  const [selectedTutor, setSelectedTutor] = useState(null);

  useEffect(() => {
    if (s_tutor?.data) {
      const tutors = Array.isArray(s_tutor.data)
        ? s_tutor.data
        : [s_tutor.data];

      console.log("tutors:", tutors);

      const options = tutors.map((tutor) => ({
        label: `${tutor.auth_user.first_name} ${tutor.auth_user.last_name} (${tutor.auth_user.username})`,
        value: tutor.auth_user.id,
      }));

      console.log("Mapped options:", options);

      setTutorOptions(options);

      if (options.length > 0) {
        setSelectedTutor(options[0]);
      }
    }
  }, [s_tutor]);
  const LinkbyTutor = async () => {
    const form = new FormData();
    form.append("enquiry_id", parmas?.id);
    form.append("tutor_id", selectedTutor.value);
    if (selectedTutor && parmas.id) {
      Tutorsmodel.linkedtutor(form)
        .then((responce) => {
          toggleModal();
          getlinktutorlist();
        })
        .catch((error) => {
          toast(error?.response?.data?.message, "warning");
        });
    }
  };
  const Unlink = (tutor_id, enquiry_id) => {
    const form = new FormData();
    form.append("tutor_id", tutor_id);
    form.append("enquiry_id", parmas?.id);

    const tutor = form.get("tutor_id");
    console.log("tutot testing", tutor);
    Tutorsmodel.Unlinkedtutor(form)
      .then((responce) => {
        toast("Successfully Unlink tutor", "success");
        getlinktutorlist();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  return (
    <>
      <Container className="pt-7">
        <div className="col mt-4">
          {/* <Button
            style={{
              marginBottom: "5px",
              backgroundColor: "#080278",
              color: "white",
              border: "none",
            }}
          >
            {" "}
            Find Tutor Manualy
          </Button> */}
          <Row>
            <Col md={9}></Col>
            <Col md={3}>
              <Input
                id="forType"
                type="select"

                // onChange={(e) => {
                //   interViewUser(e.target.value, "board");
                // }}
              >
                <option value="">Select Student</option>
                <option value="Saurabh">Saurabh Singh</option>
                <option value="Pawan">Pawan kol </option>
              </Input>
            </Col>
          </Row>
        </div>

        <Row>
          <div className="col mt-4">
            <Card className="w-100" style={{ borderRadius: ".5rem" }}>
              <CardHeader
                className="p-2 ml-3"
                style={{ color: "black", fontWeight: "bold" }}
              >
                Parent Basice Details{" "}
              </CardHeader>
              <div className="shadow-sm" style={{ backgroundColor: "#f5f5f5" }}>
                <CardBody className="p-0 pl-4">
                  <Row>
                    <Col size="3">
                      {/* <div className="top-card-div"> */}
                      <div
                        style={{
                          lineHeight: "13px",
                          paddingTop: "15px",
                        }}
                      >
                        <p>
                          {" "}
                          <span style={{ color: "#999896" }}>
                            Parent Name -
                          </span>
                          {/* - {employeeDetails?.designation} */}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {`${parent?.userData?.first_name} ${parent?.userData?.last_name}`}
                          </p>
                        </p>
                      </div>
                      {/* </div> */}
                    </Col>
                    <Col size="3">
                      <div
                        style={{
                          lineHeight: "13px",
                          paddingTop: "15px",
                        }}
                      >
                        <p>
                          <span style={{ color: "#999896" }}>Mobile no -</span>{" "}
                          {/* - {employeeDetails?.roleName} */}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parent?.userData?.username}
                          </p>
                        </p>
                      </div>
                    </Col>
                    <Col size="3">
                      <div
                        style={{
                          lineHeight: "13px",
                          paddingTop: "15px",
                        }}
                      >
                        <p>
                          <span style={{ color: "#999896" }}>Gender -</span>{" "}
                          {/* - {employeeDetails?.roleName} */}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {" "}
                            {dataList?.gender}
                          </p>
                        </p>
                      </div>
                    </Col>
                    <Col size="3">
                      <div
                        style={{
                          lineHeight: "13px",
                          paddingTop: "15px",
                        }}
                      >
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>
                            Email Address -
                          </span>{" "}
                          <br />{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parent?.userData?.email}
                          </p>
                          
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <hr className="mt-0 mb-4" />
                  <Row>
                    <Col size="3">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>
                            Mode of Tuition -
                          </span>{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parent?.data?.class_type}
                          </p>
                         
                        </p>
                      </div>
                    </Col>
                    <Col size="3">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>Location -</span>{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {dataList?.location}
                          </p>
                        
                        </p>
                      </div>
                    </Col>
                    <Col size="3">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>State -</span>{" "}
                          <br />{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {" "}
                            {dataList?.state}
                          </p>
                          
                        </p>
                      </div>
                    </Col>
                    <Col size="3">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>City -</span>{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {dataList?.city}
                          </p>
                          
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <hr className="mt-0" />
                  <Row>
                    <Col size="4">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>
                            Payment Status -
                          </span>{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parent?.data?.payment_status}
                          </p>
                         
                        </p>
                      </div>
                    </Col>
                    <Col size="4">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>By Pass Offer Payment -</span>{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parent?.data?.bypass_offer_payment}
                          </p>
                          
                        </p>
                      </div>
                    </Col>
                    <Col size="4">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>package_details -</span>{" "}
                          <br />{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {" "}
                          
                          </p>
                         
                        </p>
                      </div>
                    </Col>
                   
                  </Row>
                  <hr className="mt-0" />
                </CardBody>
                {/*<Row className="mb-2">
                  <Col md={12}>
                    <Button
                      type="submit"
                      // style={{ float: "right", marginTop: "20px" }}
                      onClick={toggleModal4}
                      style={{
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                        float: "right",
                        marginRight: "20px",
                      }}
                    >
                      Edit
                    </Button>
                  </Col>
                </Row>*/}
              </div>
            </Card>
          </div>
          <div className="col mt-4">
            {true && (
              <Row>
                <div className="col mt-3">
                  <Card className="shadow">
                    <CardHeader className="border-0 d-flex justify-content-between ">
                      <h3 className="mb-0">Students List</h3>
                    </CardHeader>

                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th scope="col">S.No.</th>
                          <th scope="col">Student NAME</th>
                          <th scope="col">Academic</th>
                          <th scope="col">Board</th>
                          <th scope="col">Class</th>
                          <th scope="col">Subject</th>

                          <th scope="col">Gender</th>
                          <th scope="col">Date of Birth</th>
                          <th scope="col"> School/College/University Name</th>
                          <th scope="col">Preferred Time Duration</th>
                          <th scope="col">Tuition Tenure</th>
                          <th scope="col">Location Preference</th>
                          {/* <th scope="col"> Enquiry For</th> */}
                          <th scope="col"> Loaction City</th>
                          <th scope="col"> Tutors Level</th>
                          {/*<th scope="col">Action</th>*/}
                        </tr>
                      </thead>

                      {true && (
                        <tbody>
                          {allStudentget?.length > 0 ? (
                            allStudentget?.map((item, index) => {
                              console.log("date-stude", item);
                              return (
                                <tr
                                  key={item._id}
                                  style={{ cursor: "pointer" }}
                                >
                                  <td>{index + 1}</td>
                                  <td>{item?.name || "-"}</td>
                                  <td>{item?.student_name || "-"}</td>
                                  <td>{item?.student_name || "-"}</td>
                                  <td>{item?.student_name || "-"}</td>
                                  <td>{item?.subjects || "-"}</td>
                                  <td>{item?.gender || "-"}</td>
                                  <td> {item?.dob || "-"}</td>
                                  <td>{item?.school_name || "-"}</td>
                                  <td>{item?.preferrd_time || "-"}</td>
                                  <td>{item?.term || "-"}</td>
                                  <td>{item?.location || "-"}</td>
                                  {/* <td  >{item?.Enquiry_For || "Student"}</td> */}
                                  <td>{item?.city || "-"}</td>
                                  <td>{item?.tutor_level || "-"}</td>
                                  {/*<td
                                    className="pl-4 p-0"
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      // justifyContent: "center",
                                      // alignItems: "center",
                                    }}
                                  >
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="eyeTooltips"
                                    >
                                      Edit
                                    </UncontrolledTooltip>
                                    <Link
                                      id="eyeTooltips"
                                      style={{
                                        margin: "0 5px",
                                        fontSize: "15px",
                                        color: "blue",
                                        // backgroundColor: "#f5f5f5",
                                        alignItems: "center",
                                        display: "inline-block",
                                        marginTop: "10px",
                                        // padding: "5px", // Optional: Add padding for better appearance
                                        borderRadius: "30%", // Optional: Make it a circle
                                      }}
                                      tag={Link}
                                      to={
                                        `/admin/viewenquiry/EditEnquriParentDetails/${parmas.mid}/${parmas.id}/${item.id}`
                                      }
                                    >
                                      <i className="fa-solid fa-pen-to-square"></i>
                                    </Link>
                                    {/* 
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="userTooltip"
                                    >
                                      Delete
                                    </UncontrolledTooltip>
                                    <p
                                      style={{
                                        margin: "0 8px",
                                        fontSize: "15px",
                                        color: "red",
                                        marginTop: "10px",
                                        // backgroundColor: "#f5f5f5",
                                        display: "inline-block",
                                        // padding: "5px", // Optional: Add padding for better appearance
                                        borderRadius: "20%", // Optional: Make it a circle
                                      }}
                                      id="userTooltip"
                                    // onClick={() => handleDel(item.id)}
                                    >
                                      <i className="fas fa-trash"></i>
                                    </p>
                                  </td>*/}
                                </tr>
                              );
                            })
                          ) : (
                            <tr style={{ textAlign: "center" }}>
                              <td
                                colSpan="6"
                                style={{ verticalAlign: "middle" }}
                              >
                                No data found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </Table>
                  </Card>
                </div>
              </Row>
            )}
          </div>
          {/*
          <div className="col mt-4">
            <Card className="w-100" style={{ borderRadius: ".5rem" }}>
              <Row className="g-0">
                <Col md="12">
                  <CardBody className="p-4">
                    {/* <Row>
                      <Col md={6}>
                        <Label>Type of Class</Label>
                        <Input
                          id="forType"
                          type="select"
                          disabled
                          // onChange={(e) => {
                          //   interViewUser(e.target.value, "board");
                          // }}
                        >
                          <option value="">Select Class Type</option>
                          <option value="Separate Class">Separate Class</option>
                          <option value="Combined Class">Combined Class</option>
                          <option value=" SME"> SME</option>
                        </Input>
                      </Col>
                      <Col md={6}>
                        <Label>Assign to</Label>
                        <Input id="forType" type="select" disabled>
                          <option value="">Select Assign to</option>
                          <option value="Pawan">Pawan</option>
                          <option value="Amit">Amit</option>
                        </Input>
                      </Col>
                    </Row>
                    
                    <Row>
                      <Col md={6} className="mt-3">
                        <Label>Remark/Feedback (Internal)</Label>
                        <Input
                          disabled
                          type="textarea"
                          placeholder="Enter Remark/Feedback"
                        />
                      </Col>{" "}
                      <Col md={6} className="mt-3">
                        <Label>Remark/Feedback (For tutor)</Label>
                        <Input
                          disabled
                          type="textarea"
                          placeholder="Enter Remark/Feedback"
                        />
                      </Col>
                    </Row>
                    
                     <div style={{ marginTop: "10px" }}>
                      <Row>
                        <Col md={12} style={{ float: "right" }}>
                          <Button
                            type="submit"
                            style={{
                              backgroundColor: "green",
                              color: "white",
                              float: "right",
                            }}
                            // tag={Link}
                            // to={`/admin/qualifiedenquiriesviewpage`}
                            // onClick={toggleModal1}
                          >
                            Qualified
                          </Button>
                          <Button
                            type="submit"
                            style={{
                              backgroundColor: "#fcb603",
                              color: "white",
                              float: "right",
                            }}
                            onClick={toggleModal1}
                          >
                            Pending
                          </Button>
                          <Button
                            type="submit"
                            // style={{ float: "right", marginTop: "20px" }}
                            onClick={toggleModal2}
                            style={{
                              backgroundColor: "#fc0f03",
                              color: "white",
                              float: "right",
                            }}
                          >
                            Disqualified
                          </Button>
                        </Col>
                      </Row>
                    </div> 
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </div>
                      */}
          <div className="col mt-4">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0" style={{ color: "green" }}>
                  Linktutors Enquiries
                </h3>
                <div className="d-flex flex-row">
                  <Input
                    className="mr-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                  />
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Tutors Name</th>
                    <th scope="col">Mode of Tuition</th>
                    <th scope="col">Parent approval</th>
                    <th scope="col">Demo Sheduled</th>
                    <th scope="col">Demo Approved</th>

                    <th scope="col">Demo Request</th>
                    <th scope="col">Parent Feedback</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {linktutordata?.data?.map((item, key) => {
                    console.log("linkdata", item);
                    return (
                      <tr>
                        <td key={key}>{key + 1}</td>
                        <td className="p-0 pl-3">
                          {" "}
                          <Link
                            to={`/admin/tutors/tutorsprofile/${item?.auth_user?.id}/${item?.auth_user?.username}`}
                          >
                            {item?.auth_user?.first_name}{" "}
                            {item?.auth_user?.last_name}{" "}
                          </Link>
                        </td>
                        <td>{item?.tutorApi_tutor?.modeOfTution}</td>
                        <td>{item?.parentApprovel}</td>
                        <td>
                          {item?.demoSheduled !== undefined
                            ? item?.demoSheduled
                              ? "true"
                              : "false"
                            : "null"}
                        </td>

                        <td>{item?.demoApproved}</td>
                        <td>
                          {""}
                          {item?.demoRequest}
                        </td>
                        <td>
                          {""}
                          {item?.parentFeedback}
                        </td>
                        <td
                          className="p-0"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            // justifyContent: "center",
                            // alignItems: "center",
                            // marginTop: "20px",
                          }}
                        >
                          <UncontrolledTooltip
                            placement="bottom"
                            target="eyeTooltip"
                          >
                            Schedule Demo
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="eyeTooltip"
                            onClick={() => {
                              setinlinkEnquryid(item?.enquiry_id);
                              setinlinkTutorid(item?.tutor_id);
                              toggleModal7();
                            }}
                            // tag={Link}
                          >
                            <i class="fa-solid fa-calendar-days"></i>
                          </Link>

                          <UncontrolledTooltip
                            placement="bottom"
                            target="uuserTooltip"
                          >
                            Demo Given
                          </UncontrolledTooltip>
                          <p
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="uuserTooltip"
                            onClick={() => {
                              toggleModal6();
                              setinlinkEnquryid(item?.enquiry_id);
                              setinlinkTutorid(item?.tutor_id);
                            }}
                          >
                            <i class="fa-regular fa-id-card"></i>
                          </p>

                          <UncontrolledTooltip
                            placement="bottom"
                            target="CreatePackage"
                          >
                            Create Package
                          </UncontrolledTooltip>
                          <p
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="CreatePackage"
                            onClick={() => {
                              toggleModal5();
                              setinlinkEnquryid(item?.enquiry_id);
                              setinlinkTutorid(item?.tutor_id);
                            }}
                          >
                            <i class="fa-solid fa-hand-holding-heart"></i>
                          </p>
                          <UncontrolledTooltip
                            placement="bottom"
                            target="CreateClass"
                          >
                            Create Class
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            to={`/admin/classes/addclasss/${parmas?.mid}/${item?.auth_user?.username}/${parmas?.id}`}
                            id="CreateClass"
                            // onClick={toggleModal2}
                          >
                            <i class="fa-solid fa-plus"></i>
                          </Link>
                          <UncontrolledTooltip
                            placement="bottom"
                            target="Unlink"
                          >
                            UnLink Tutor
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "red",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="Unlink"
                            onClick={() => {
                              Unlink(item?.tutor_id, item?.enquiry_id);
                            }}
                          >
                            <i class="fa-solid fa-link-slash"></i>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>

          <div className="col mt-4">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0" style={{ color: "orange" }}>
                  Shortlisted Tutors
                </h3>

                <div className="d-flex flex-row">
                  <Input
                    className="mr-1"
                    type="text"
                    placeholder="Search"
                    size="sm"
                  />
                  <Button
                    style={{
                      backgroundColor: "#080278",
                      color: "white",
                      border: "none",
                      width: "100%",
                    }}
                    size="sm"
                    onClick={toggleModal}
                  >
                    {" "}
                    Shortlisted by Tutors
                  </Button>
                  <Link
                    to={`/admin/shortlistUser/${parmas.id}/${parmas.mid}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <i class="fa-sharp fa-solid fa-share"></i>
                  </Link>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Tutors Name (Mobile No)</th>
                    <th scope="col">Mode of Tuition</th>
                    <th scope="col">Distance</th>
                    <th scope="col">Effective Distance</th>
                    <th scope="col">Location</th>
                    <th scope="col">Profile Status</th>
                    {/* <th scope="col">Status</th> */}
                    <th>Action</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {shortlistdata?.data?.data?.map((item, key) => {
                    console.log("mobile", item);
                    return (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td className="p-0 pl-5">
                          {" "}
                          <Link
                            to={`/admin/tutors/tutorsprofile/${item?.auth_user?.id}/${item?.auth_user?.username}`}
                          >{`${item?.auth_user?.first_name} ${item?.auth_user?.last_name}`}</Link>
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                          >
                            {" "}
                            {item?.auth_user?.username}{" "}
                            <span style={{ marginLeft: "3px" }}>
                              <i class="fa-solid fa-phone"></i>
                            </span>
                          </span>
                        </td>
                        <td>{item?.tutorApi_tutor?.modeOfTution}</td>
                        <td>not available</td>
                        <td>not available</td>
                        <td>{item?.tutorApi_tutor?.state}</td>
                        <td>{item?.profileStatus}</td>
                        {/* <td>Demo Schedule</td> */}
                        <td
                          className="p-0"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            // marginTop: "20px",
                          }}
                        >
                          {/*  <UncontrolledTooltip
                            placement="bottom"
                            target="viewAbout"
                          >
                            View About
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="viewAbout"
                            to={`/admin/tutors/tutorsprofile/${parmas?.id}/${item?.tutor_id}`}
                          // tag={Link}
                          >
                            <i class="fa-solid fa-eye"></i>
                          </Link>
*/}
                          <UncontrolledTooltip
                            placement="bottom"
                            target="userTooltipss"
                          >
                            Link Tutors
                          </UncontrolledTooltip>
                          <p
                            style={{
                              cursor: "pointer",
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "green",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="userTooltipss"
                            onClick={() => {
                              Linktutor();
                              settutorid(item?.tutor_id);
                            }}
                          >
                            <i class="fa-solid fa-link"></i>
                          </p>
                          {/* 
                          <UncontrolledTooltip
                            placement="bottom"
                            target="TutorProfile"
                          >
                            Tutor Profile
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="TutorProfile"
                            to={`/admin/tutors/tutorsprofile/${parmas?.id}/${item?.tutor_id}`}
                          // tag={Link}
                          >
                            <i class="fa-solid fa-user"></i>
                          </Link>
*/}
                          <UncontrolledTooltip
                            placement="bottom"
                            target="AddProfile"
                          >
                            Add About
                          </UncontrolledTooltip>

                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="AddProfile"
                            to={`/admin/addprofile/${parmas?.id}/${item?.tutor_id}/${parmas?.mid}`}

                            // tag={Link}
                          >
                            <i class="fa-solid fa-plus"></i>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>

          <div className="col mt-4">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Interested Tutors</h3>
                <div className="d-flex flex-row">
                  <Input
                    className="mr-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                  />
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Tutors Name (Mobile No)</th>
                    <th scope="col">Mode of Tuition</th>
                    <th scope="col">Distance</th>
                    <th scope="col">Effective Distance</th>
                    <th scope="col">Location</th>
                    {/* <th scope="col">Status</th> */}
                    <th>Action</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {i_tutor?.data?.map((item, key) => {
                    console.log("irpn", item);
                    return (
                      <tr>
                        <td>{key + 1}</td>
                        <td className="p-0 pl-5">
                          {" "}
                          <Link
                            to={`/admin/tutors/tutorsprofile/${item?.auth_user?.id}/${item?.auth_user?.username}`}
                          >{`${item?.auth_user?.first_name} ${item?.auth_user?.last_name}`}</Link>
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                          >
                            {" "}
                            {item?.auth_user?.username}
                            <span style={{ marginLeft: "3px" }}>
                              <i class="fa-solid fa-phone"></i>
                            </span>
                          </span>
                        </td>
                        <td>{item?.tutorApi_tutor?.modeOfTution}</td>
                        <td>not available</td>
                        <td>not available</td>
                        <td>{item?.tutorApi_tutor?.state}</td>
                        {/* <td>Demo Schedule</td> */}
                        <td
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <UncontrolledTooltip
                            placement="top"
                            target="eyeTooltipss"
                          >
                            View Profile
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="eyeTooltipss"
                            to={`/admin/tutors/tutorsprofile/${item?.auth_user?.id}/${item?.auth_user?.username}`}
                            // tag={Link}
                          >
                            <i class="fa-solid fa-eye"></i>
                          </Link>
                          {/*
                          <UncontrolledTooltip
                            placement="top"
                            target="Linktutors"
                          >
                            Link Tutors
                          </UncontrolledTooltip>
                          <p
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "green",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="Linktutors"
                            onClick="{AssignTutors}"
                          >
                            <i class="fa-solid fa-link"></i>
                          </p>
*/}
                          <UncontrolledTooltip
                            placement="top"
                            target="Shortlisted"
                          >
                            Shortlisted Tutors
                          </UncontrolledTooltip>
                          <p
                            style={{
                              cursor: "pointer",
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "orange",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="Shortlisted"
                            onClick={() => {
                              shortlistTutors(item?.tutor_id
                              );
                              setenquryid();
                              settutorid(item?.tutor_id
                              );
                            }}
                          >
                            <i class="fa-solid fa-list"></i>
                          </p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>

          <div className="col mt-4">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Suggested Tutors</h3>
                <div className="d-flex flex-row">
                  <Input
                    className="mr-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                  />
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Tutors Name (Mobile No)</th>
                    <th scope="col">Mode of Tuition</th>
                    <th scope="col">Distance</th>
                    <th scope="col">Effective Distance</th>
                    <th scope="col">Location</th>
                    {/* <th scope="col">Status</th> */}
                    <th>Action</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {s_tutor?.data?.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td className="p-0 pl-5">
                          {" "}
                          <Link
                            to={`/admin/tutors/tutorsprofile/${item?.auth_user?.id}/${item?.auth_user?.username}`}
                          >{`${item?.auth_user?.first_name} ${item?.auth_user?.last_name}`}</Link>
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                          >
                            {" "}
                            {item?.mobile}
                            <span style={{ marginLeft: "3px" }}>
                              <i class="fa-solid fa-phone"></i>
                            </span>
                          </span>
                        </td>
                        <td>{item?.modeOfTution}</td>
                        <td>not available</td>
                        <td>not available</td>
                        <td>not available</td>
                        {/* <td>Demo Schedule</td> */}
                        <td
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <UncontrolledTooltip
                            placement="top"
                            target={`eyeTooltipss-${key}`}
                          >
                            View Profile
                          </UncontrolledTooltip>

                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id={`eyeTooltipss-${key}`}
                            // to={`/admin/classes/addclasss`}
                            to={`/admin/tutors/tutorsprofile/${item?.auth_user?.id}/${item?.auth_user?.username}`}
                            // tag={Link}
                          >
                            <i class="fa-solid fa-eye"></i>
                          </Link>
                          {/*
                          <UncontrolledTooltip
                            placement="top"
                            target="Linktutors"
                          >
                            Link Tutors
                          </UncontrolledTooltip>
                          <p
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "green",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="Linktutors"
                            onClick="{AssignTutors}"
                          >
                            <i class="fa-solid fa-link"></i>
                          </p>
*/}
                          <>
                            <UncontrolledTooltip
                              placement="top"
                              target={`Shortlistedd-${key}`}
                            >
                              Shortlisted Tutors
                            </UncontrolledTooltip>
                            <p
                              style={{
                                cursor: "pointer",
                                margin: "0 5px",
                                fontSize: "15px",
                                color: "orange",
                                alignItems: "center",
                                display: "inline-block",
                                marginTop: "10px",
                                borderRadius: "30%", // Optional: Make it a circle
                              }}
                              id={`Shortlistedd-${key}`} // Unique ID for each item
                              onClick={() => {
                                shortlistTutors(item?.user_id);
                                setenquryid();
                                settutorid(item?.user_id);
                              }}
                            >
                              <i class="fa-solid fa-list"></i>
                            </p>
                          </>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>
        </Row>

        <Modal isOpen={modal1} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <h4> Assign Tutors</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                {/* <FormGroup>
                  <Label for="exampleEmail">Select Tutors</Label>
                  <Input
                    id="forType"
                    type="select"
                    // onChange={(e) => {
                    //   interViewUser(e.target.value, "board");
                    // }}
                  >
                    <option value="">select Option</option>
                    {dataList &&
                      dataList?.map((item, index) => {
                        return (
                          <option value={item.mobile}>
                            {item.user?.first_name} ({item?.mobile})
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup> */}
                <FormGroup>
                  <Label for="tutorSelect">Select Tutor</Label>
                  <Select
                    id="tutorSelect"
                    options={tutorOptions} // Tutor options passed to the Select
                    value={selectedTutor} // Pre-selected value
                    onChange={(option) => setSelectedTutor(option)} // Update selected value
                    placeholder="Select Tutor"
                    isSearchable={true} // Enable search
                  />
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                onClick={LinkbyTutor}
              >
                Link Tutor
              </Button>
            </div>
          </ModalBody>
        </Modal>
        {/*schedule demo model */}

        <Modal isOpen={modal7} toggle={toggleModal7}>
          <ModalHeader toggle={toggleModal7}>
            <h4>Demo Schedule</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={adddemo}>
              <Row>
                <Col md={6}>
                  <Label for="exampleEmail">Date</Label>
                  <Input type="date" name="date" />
                </Col>

                <Col md={6}>
                  {" "}
                  <Label for="exampleEmail">Time</Label>
                  <Input
                    id="forType"
                    type="select"
                    name="time"
                    // onChange={(e) => {
                    //   interViewUser(e.target.value, "board");
                    // }}
                  >
                    <option value="">select Option</option>
                    <option value="1:00AM">1AM</option>
                    <option value="2:00AM">2AM</option>
                    <option value="3:00AM">3AM</option>
                    <option value="4:00AM">4AM</option>
                    <option value="5:00AM">5AM</option>
                    <option value="6:00AM">6AM</option>
                    <option value="7:00AM">7AM</option>
                    <option value="8:00AM">8AM</option>
                    <option value="9:00AM">9AM</option>
                    <option value="10:00AM">10AM</option>
                    <option value="11:00AM">11AM</option>
                    <option value="12:00AM">12AM</option>
                    <option value="1:00PM">1PM</option>
                    <option value="2:00PM">2PM</option>
                    <option value="3:00PM">3PM</option>
                    <option value="4:00PM">4PM</option>
                    <option value="5:00PM">5PM</option>
                    <option value="6:00PM">6PM</option>
                    <option value="7:00PM">7PM</option>
                    <option value="8:00PM">8PM</option>
                    <option value="9:00PM">9PM</option>
                    <option value="10:00PM">10PM</option>
                    <option value="11:00PM">11PM</option>
                    <option value="12:00PM">12PM</option>
                  </Input>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md={12}>
                  <Label>Mode</Label>

                  <Input
                    name="mode"
                    type="select"
                    onChange={handleChangeMode}
                    required
                  >
                    <option value="">Select mode</option>
                    <option value="online">online</option>
                    <option value="offline">offline </option>
                  </Input>
                </Col>
                {selecttMode === "online" ? (
                  <Col md={12} className="mt-2">
                    <Label> Meet Link (Include https) </Label>
                    <Input
                      name="modeData"
                      type="text"
                      placeholder="https://meet.google.com/yvs-yzvb-dfa"
                      required
                    />
                  </Col>
                ) : null}
                {selecttMode === "offline" ? (
                  <>
                    {/*   <Col md={6}>
                      <Label> Address</Label>
                      <Input
                        name="modeData"
                        type="text"
                        placeholder="Enter Address"
                        required
                      />
                    </Col> */}
                  </>
                ) : null}
              </Row>

              <Row className="mt-3">
                <Col md={6}>
                  <Label>Consultant</Label>

                  <Input name="consultant" type="select" required>
                    <option value="">Select Consultant</option>
                    {supervisorlist?.map((item,index)=>{
                      return(
                        <option value={item?.user_id}>{item?.auth_user?.first_name}</option>
                      )
                    })}
                   
                 
                  </Input>
                </Col>
                <Col md={6}>
                  <Label> Daily Tuition Duration (in minutes)</Label>
                  <Input
                    name="daily_tuition_duration"
                    type="number"
                    min={1}
                    placeholder="Session duration in minutes"
                    required
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={6}>
                  <Label> Total Sessions in a Cycle</Label>
                  <Input
                    name="total_session_in_cycle"
                    type="number"
                    min={1}
                    placeholder="Sessions in a cycle"
                    required
                  />
                </Col>
                <Col md={6}>
                  <Label> Total Fees per cycle</Label>
                  <Input
                    name="total_fees_per_cycle"
                    type="number"
                    min={1}
                    step="any"
                    placeholder="Fees per cycle"
                    required
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={12}>
                  <Label> Note</Label>
                  <Input
                    name="notes"
                    type="textarea"
                    placeholder="Note"
                    required
                  />
                </Col>
              </Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal7}>
                  Cancel
                </Button>

                <Button
                  color="primary"
                  type="submit"
                  style={{ float: "right", marginLeft: "5%" }}
                >
                  {isLoadingDemoAdd ? <Loader /> : "Save"}
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal6} toggle={toggleModal6}>
          <ModalHeader toggle={toggleModal6}>
            <h4> Demo Given</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={demogiven}>
              <Label> Last Year overall score</Label>
              <Input
                name="overall_score"
                type="textarea"
                placeholder="Enter Last Year overall score"
              />
              <Label> Guardian's Core Need</Label>
              <Input
                name="core_need"
                type="textarea"
                placeholder="Enter Guardian's Core Need
"
              />

              <Label> Student's Unexpected hazzard </Label>
              <Input
                name="unexpected_hazzard"
                type="textarea"
                placeholder="Enter Student's Unexpected hazzard "
              />
              <Label> Earlier Taught by</Label>
              <Input
                name="taught_by"
                type="textarea"
                placeholder="Enter Earlier Taught by 
"
              />
              <Label> Additional Remark</Label>
              <Input
                name="remark"
                type="textarea"
                placeholder="Enter Additional Remark
"
              />

              <Label> Parent A/C Feedback</Label>
              <Input
                name="parent_feedback"
                type="textarea"
                placeholder="Enter Parent A/C Feedback"
              />
              <Label> Tutor A/C Feedback</Label>
              <Input
                name="tutor_feedback"
                type="textarea"
                placeholder="Enter Student A/C Feedback"
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal6}>
                  Cancel
                </Button>

                <Button
                  color="primary"
                  type="submit"
                  style={{ float: "right", marginLeft: "5%" }}
                  onClick={toggleModal6}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal4} toggle={toggleModal4} size="lg">
          <ModalHeader toggle={toggleModal4}>
            <h4> Edit Parent Details</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmiteditParentDetails}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent Name </Label>
                    <Input
                      type="text"
                      placeholder="Enter Name"
                      name="first_name"
                      defaultValue={dataList?.parent_name}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent Last Name</Label>
                    <Input
                      type="text"
                      placeholder="Enter Last Name"
                      name="last_name"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Email Address</Label>
                    <Input
                      type="text"
                      placeholder="Enter Email Address"
                      name="email"
                      defaultValue={dataList?.email}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mobile no</Label>
                    <Input
                      type="text"
                      placeholder="Enter Mobile no"
                      disabled
                      defaultValue={dataList?.mobile}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Gender</Label>
                    <Input
                      id="forType"
                      type="select"
                      name="gender"
                      defaultChecked={dataList?.gender}
                    >
                      <option value="">Select Gender </option>
                      <option value="Male">Male</option>
                      <option value="FeMale">FeMale</option>
                      <option value="other">other</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mode of Tuition</Label>

                    <Input
                      id="forType"
                      name="modeOfTution"
                      type="select"
                      defaultValue={dataList?.mode}
                    >
                      <option value="">Select Mode </option>
                      <option value="online">online</option>
                      <option value="offline">offline</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">State</Label>
                    <Input
                      id="forType"
                      name="state"
                      type="select"
                      defaultValue={dataList?.state}
                    >
                      <option value="">Select State </option>
                      <option value="Mp">Mp</option>
                      <option value="Up">Up</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Loaction</Label>
                    <Input
                      type="text"
                      placeholder="Enter Loaction"
                      name="location"
                      defaultValue={dataList?.location}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">City</Label>
                    <Input
                      id="forType"
                      name="city"
                      type="select"
                      defaultValue={dataList?.city}
                    >
                      <option value="">Select City </option>
                      <option value="Bhopla">Bhopla</option>
                      <option value="Indora">Indora</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                  }}

                  // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal5} toggle={toggleModal5}>
          <ModalHeader toggle={toggleModal5}>
            <h4> Create Package</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmit1}>
              <Input name="session" id="forType" type="select">
                <option value="">Select Session</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
              </Input>

              <FormGroup className="mt-3">
                <Input name="amount" type="text" placeholder="Enter Amount" />
              </FormGroup>
              <FormGroup>
                <div
                  style={{
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h3>Package Details</h3>{" "}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Label>Bypass Payment</Label>
                    <Input
                      name="bypass_offer_payment"
                      type="select"
                      style={{ width: "30%", marginLeft: "8px" }}
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Input>
                  </div>
                </div>
                <Label>Name</Label>
                <Input
                  type="text"
                  placeholder="Enter Name"
                  id="name"
                  name="package_details[name]"
                />
                <Label>Details</Label>
                <Input
                  type="textarea"
                  placeholder="Enter  Details"
                  id="details"
                  name="package_details[details]"
                />
                <Label>Discounted Price</Label>
                <Input
                  type="text"
                  placeholder="Enter Discounted prise"
                  id="discounted_price"
                  name="package_details[discounted_price]"
                />
                <Label>Actual Price</Label>
                <Input
                  id="actual_price"
                  name="package_details[actual_price]"
                  type="text"
                  placeholder="Enter Actual price"
                />
              </FormGroup>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal5}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{ float: "right", marginLeft: "5%" }}
                  onClick={toggleModal5}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default LinkTutorsEnquiries;
